/**
 * Mirrors of WordPress constants for expressing human-readable intervals in
 * their respective number of milliseconds.
 *
 * Please note that these values are approximate and are provided for convenience.
 * For example, MONTH_IN_MILLISECONDS wrongly assumes every month has 30 days and
 * YEAR_IN_MILLISECONDS does not take leap years into account.
 */

export const SECOND_IN_MILLISECONDS = 1000;
export const MINUTE_IN_MILLISECONDS = 60 * SECOND_IN_MILLISECONDS;
export const HOUR_IN_MILLISECONDS = 60 * MINUTE_IN_MILLISECONDS;
export const DAY_IN_MILLISECONDS = 24 * HOUR_IN_MILLISECONDS;
export const WEEK_IN_MILLISECONDS = 7 * DAY_IN_MILLISECONDS;
export const MONTH_IN_MILLISECONDS = 30 * DAY_IN_MILLISECONDS;
export const YEAR_IN_MILLISECONDS = 365 * DAY_IN_MILLISECONDS;
